import React from 'react';
import PropTypes from 'prop-types';
import {
  IonModal,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonText,
  IonImg,
} from '@ionic/react';

function BleScanRestartModal({ isOpen, setLoyaltyTypeModal, restartAction }) {
  const onRestartAction = () => {
    setLoyaltyTypeModal(null);
    restartAction();
  }

  const onCloseAction = () => {
    setLoyaltyTypeModal(null);
  }

  return (
    <IonModal isOpen={isOpen} className="custom-ble-alert">
      <IonContent>
        <IonList>
          <IonItem lines="none" className="mt-3x mb">
            <div className="d-flex-content d-flex-center">
              <IonImg src="/assets/ble-scan-icon.png" className="ble-scan-icon-medium" />
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <h3>Finding your tab...</h3>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none">
            <div className="d-flex-content d-flex-center">
              <IonLabel className="ion-text-wrap">
                <p className="custom-alert-message">Tap your phone to the reader and hold until you hear a beep.</p>
              </IonLabel>
            </div>
          </IonItem>

          <IonItem lines="none" className="mt-5x">
            <div className="d-flex-row-center">
              <IonButton
                color="tertiary"
                expand="block"
                fill="solid"
                type="button"
                onClick={onRestartAction}
                className="loyalty-button-wrap mr-1"
              >
                <IonText color="light"><p className="loyalty-button-size">TRY AGAIN</p></IonText>
              </IonButton>

              <IonButton
                color="medium"
                expand="block"
                fill="solid"
                type="button"
                onClick={onCloseAction}
                className="loyalty-button-wrap mr-1"
              >
                <IonText color="light"><p className="loyalty-button-size">Close</p></IonText>
              </IonButton>
            </div>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

BleScanRestartModal.propTypes = {
  isOpen: PropTypes.bool,
  setLoyaltyTypeModal: PropTypes.func,
  restartAction: PropTypes.func,
};

export default BleScanRestartModal;
